import { useEffect } from "react";
import { createPortal } from "react-dom";

import { Typo } from "../../Typo";

type ToastProps = {
  message: string;
  onClose: () => void;
};

// Small self-dismissing notification for row actions (e.g. "Link copied",
// "Coming soon" for flows out of scope for this pass). Local to SubIBReport —
// not exported from the package root.
export const Toast = ({ message, onClose }: ToastProps) => {
  useEffect(() => {
    if (!message) return;
    const id = setTimeout(() => onClose(), 3000);
    return () => clearTimeout(id);
  }, [message, onClose]);

  if (!message) return null;

  return createPortal(
    <div
      role="status"
      className="fixed bottom-6 left-1/2 z-[60] flex -translate-x-1/2 items-center gap-3 rounded-lg bg-surface-inverse-primary px-4 py-3 shadow-lg"
    >
      <Typo element="span" type="labelSM" textColor="text-text-inverse-primary">
        {message}
      </Typo>
      <button
        type="button"
        onClick={onClose}
        aria-label="Dismiss"
        className="text-text-inverse-primary opacity-70 hover:opacity-100"
      >
        ✕
      </button>
    </div>,
    document.body,
  );
};
